import React from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { FaCalendarAlt, FaUser, FaArrowRight, FaArrowLeft } from 'react-icons/fa';
import { getPostById, getRelatedPosts, blogPosts } from './blogData';
import './Blog.css';

const BlogPost = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const post = getPostById(id);

  // If post not found, redirect to blog page
  if (!post) {
    return (
      <div className="blog-post-page">
        <div className="page-header">
          <div className="container">
            <h1>Blog</h1>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <Link to="/blog">Blog</Link>
              <span>/</span>
              <span>Not Found</span>
            </div>
          </div>
        </div>
        <section className="section">
          <div className="container" style={{ textAlign: 'center' }}>
            <h2>Post Not Found</h2>
            <p>Sorry, the blog post you're looking for doesn't exist.</p>
            <Link to="/blog" className="btn btn-primary" style={{ marginTop: '20px' }}>
              <FaArrowLeft /> Back to Blog
            </Link>
          </div>
        </section>
      </div>
    );
  }

  const relatedPosts = getRelatedPosts(id, 3);

  // If not enough related posts in same category, fill with other posts
  const displayRelatedPosts = relatedPosts.length >= 3
    ? relatedPosts
    : [...relatedPosts, ...blogPosts.filter(p => p.id !== parseInt(id) && !relatedPosts.includes(p)).slice(0, 3 - relatedPosts.length)];

  return (
    <div className="blog-post-page">
      <div className="page-header">
        <div className="container">
          <h1>Blog</h1>
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <Link to="/blog">Blog</Link>
            <span>/</span>
            <span>{post.category}</span>
          </div>
        </div>
      </div>

      <section className="blog-post-content section">
        <div className="container">
          <div className="post-header">
            <span className="post-category">{post.category}</span>
            <h1 className="post-title">{post.title}</h1>
            <div className="post-meta" style={{ justifyContent: 'center' }}>
              <span><FaUser /> {post.author}</span>
              <span><FaCalendarAlt /> {post.date}</span>
            </div>
          </div>

          <div className="post-featured-image">
            <img src={post.image} alt={post.title} />
          </div>

          <div className="post-body" dangerouslySetInnerHTML={{ __html: post.content }} />

          {/* <div className="post-tags">
            <strong>Tags: </strong>
            {post.tags.map((tag, index) => (
              <span key={index}>{tag}</span>
            ))}
          </div> */}

          {/* <div className="post-author-box">
            <img src={post.authorImage} alt={post.author} />
            <div className="author-info">
              <h4>{post.author}</h4>
              <p className="author-role">{post.authorRole}</p>
              <p>{post.authorBio}</p>
            </div>
          </div> */}

          <div className="post-navigation" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '40px' }}>
            <Link to="/blog" className="btn btn-secondary">
              <FaArrowLeft /> Back to Blog
            </Link>
            <Link to="/contact" className="btn btn-primary">
              Start Training <FaArrowRight />
            </Link>
          </div>

          {/* {displayRelatedPosts.length > 0 && (
            <div className="related-posts">
              <h3>Related Articles</h3>
              <div className="related-posts-grid">
                {displayRelatedPosts.map((relatedPost) => (
                  <Link key={relatedPost.id} to={`/blog/${relatedPost.id}`} className="blog-card">
                    <div className="blog-card-image">
                      <img src={relatedPost.image} alt={relatedPost.title} />
                      <span className="post-category">{relatedPost.category}</span>
                    </div>
                    <div className="blog-card-content">
                      <h4>{relatedPost.title}</h4>
                      <div className="post-meta">
                        <span><FaCalendarAlt /> {relatedPost.date}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          )} */}
        </div>
      </section>
    </div>
  );
};

export default BlogPost;
